import React from "react";

class EntersectFooter extends React.Component {
  state = {};
  render() {
    return (
      <div className="app-footer col-lg-12 col-sm-12 padding-top-10 padding-bottom-10 font-family footer-color">
        <div className="col-lg-2 col-sm-2">
          Entersect © {new Date().getFullYear()}
        </div>

        <div className="col-lg-2 col-sm-2">
          <a
            href="https://lp-training-videos.s3.us-east-1.amazonaws.com/LocatePLUS+Complete+User+Guide.pdf"
            className="font-family"
            alt="Link to User Guide pdf which opens in a new tab"
            target="_blank"
            rel="noopener noreferrer"
          >
            User Guide
          </a>
        </div>

        <div className="col-lg-2 col-sm-2">
          {" "}
          <a
            href="https://entersect.net/wp-content/uploads/2026/07/Entersect-Terms-of-Use.pdf"
            className="font-family"
            alt="Link to the Terms and conditions pdf which opens in a new tab"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Use
          </a>
        </div>

        <div className="col-lg-2 col-sm-2">
          <a
            href="https://entersect.net/privacy-policy/"
            className="font-family"
            alt="Link to the privacy policy pdf which opens in a new tab"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
        </div>

        <div className="col-lg-2 col-sm-2">
          <a
            href="https://entersect.net/contact/"
            className="font-family"
            alt="Link to the contact us page which opens in a new tab"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact US
          </a>
        </div>

        <div className="col-lg-2 col-sm-2">
          <a
            href="https://entersect.net/contact/"
            className="font-family"
            alt="Link to the contact us page which opens in a new tab"
            target="_blank"
            rel="noopener noreferrer"
          >
            Support
          </a>
        </div>
      </div>
    );
  }
}

export default EntersectFooter;



// WEBPACK FOOTER //
// ./src/components/navigation/FooterEntersect.js